import SubcategoryPage from '@/components/template/SubcategoryPage';

const TuraregCeilingLights = () => {
  const products = [
    {
      title: "Turareg Ceiling Model 1",
      imageSrc: "https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?auto=format&fit=crop&q=80",
      url: "/svetila/turareg-ceiling/model-1"
    },
    {
      title: "Turareg Ceiling Model 2",
      imageSrc: "https://images.unsplash.com/photo-1537118152881-be14a3b314b7?auto=format&fit=crop&q=80",
      url: "/svetila/turareg-ceiling/model-2"
    },
    {
      title: "Turareg Ceiling Model 3",
      imageSrc: "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80",
      url: "/svetila/turareg-ceiling/model-3"
    },
    {
      title: "Turareg Ceiling Model 4",
      imageSrc: "https://images.unsplash.com/photo-1590227632180-80a3bf110871?auto=format&fit=crop&q=80",
      url: "/svetila/turareg-ceiling/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Turareg Ceiling Lights"
      description="Elegantne stropne svetilke za vašo kopalnico z edinstveno obliko, ki spominja na tradicionalne tuareške vzorce. Popolna kombinacija estetike in funkcionalnosti."
      heroImage="https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default TuraregCeilingLights;